<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <template slot="header">
          <h4 class="card-title">+EV Punting Edit</h4>
        </template>
        <div>
          <form method="#" action="#" @submit.prevent="updateNews" onSubmit="document.getElementById('submit').disabled=true;"  class="form-horizontal">
            <div class="row">
              <label class="col-sm-2 col-form-label">Title</label>
              <div class="col-sm-4">
                <fg-input v-model="title" type="text" placeholder="Title for the blog">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Front Content</label>
              <div class="col-sm-4">
                <fg-input v-model="content" type="text" placeholder="Contents of the blog">
                </fg-input>
              </div>
            </div>
             <div class="row">
              <label class="col-sm-2 col-form-label">Sport Type</label>
              <div class="col-sm-4 col-md-10">
                                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Sport type"
                  v-model="type"
                >
                  <el-option
                    v-for="option in selects.countries"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Main Content</label>
              <div class="col-sm-8">
                <vue-editor v-model="contentDetail"></vue-editor>
                <br>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Image</label>
              <div class="col-sm-4">
                <!-- <fg-input v-model="imageURL" type="text" placeholder="Image URL">
                </fg-input> -->
                <el-upload class="picture"
                     action="https://jsonplaceholder.typicode.com/posts/"
                     :on-change="handlePreview"
                     :auto-upload="false"
                     :show-file-list="false">
                    <img v-if="model.imageUrl" :src="model.imageUrl" class="picture-src">
                </el-upload>
              </div>
            </div>

     
            <div class="row">
              <label class="col-sm-2 col-form-label"></label>
              <div class="col-sm-4">
                <n-button class="btn-block" native-type="submit" type="primary" id='submit' round>
                Edit
              </n-button>
              <n-button class="btn-block" @click.native="deleteNews" type="default" round>
                Delete
              </n-button>
              </div>
            </div>
          </form>
        </div>
      </card>  <!-- end card -->
    </div>
  </div>
</template>
<script>
import { Checkbox, Radio } from 'src/components/index';
import { VueEditor, Quill } from "vue2-editor";

import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from 'element-ui';

import db from '@/components/firebaseInit'
import firebase from 'firebase';
import { Upload } from 'element-ui'; 


export default {
  components: {
    Checkbox,
    Radio,
    VueEditor,
    Quill,
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload
  },
  data() {

    return {
      item_id: null,
      catagory: null,
      title: null,
      content: null,
      type: null,
      selects: {
        countries: [
          { value: "Soccer", label: "Soccer" },
          { value: "AFL", label: "AFL" },
          { value: "NFL", label: "NFL" },
          { value: "NBA", label: "NBA" },
          { value: "NRL", label: "NRL" },
          { value: "Tennis", label: "Tennis" },
          { value: "UFC", label: "UFC" },
          { value: "HorseRacing", label: "Horse Racing" }
        ],
      },
      tag: null,
      date: null,
      imageUrl: null,
      uploadValue: null,
      picture: null,
      imageData: null,
      model: {
          imageUrl: 'img/image_placeholder.jpg'
      }
    };
  },

    beforeRouteEnter(to, from, next) {
    db
      .collection('predictions').where(firebase.firestore.FieldPath.documentId(), '==', to.params.item_id)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
            vm.id = doc.id;
            vm.content = doc.data().content;
            vm.contentDetail = doc.data().contentDetail;
            vm.title = doc.data().title;
            vm.type = doc.data().type;
            vm.picture = doc.data().picture;
            vm.model.imageUrl = doc.data().picture;
          });
        });
      });
  },
   watch: {
    $route: 'fetchData'
  },
    methods: {

        handlePreview(file) {
        this.model.imageUrl = URL.createObjectURL(file.raw);
        this.imageData = event.target.files[0];
        },
        getError(fieldName) {
        return this.errors.first(fieldName);
        },
        validate() {
        return this.$validator.validateAll().then(res => {
            this.$emit('on-validated', res, this.model);
            return res;
        });
        },

    fetchData () {
      db.collection('predictions')
        .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.id = doc.id;
            this.content = doc.data().content;
            this.contentDetail = doc.data().contentDetail;
            this.type = doc.data().type;
            this.title = doc.data().title;
            this.picture = doc.data().picture;
            this.model.imageUrl = doc.data().picture;
          });
        });
    },
        updateNews () {

if(this.imageData == null){

         db.collection('predictions').where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref.update({
                    content: this.content,
                    title: this.title,
                    type: this.type,
                    contentDetail: this.contentDetail,
                    picture: this.picture

            })
            .then(() => {
              console.log('News have been Updated')
              alert("Succefully Updated Blog");
              this.$router.push('/prediction/index')
            });
          })
        })

}else{

      this.picture=null;
      let timename = Date.now();
      const storageRef=firebase.storage().ref(`${timename}`).put(this.imageData);
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
          this.picture =url;
        //   console.log(this.picture);


        db.collection('predictions').where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref.update({
                    content: this.content,
                    contentDetail: this.contentDetail,
                    title: this.title,
                    type: this.type,
                    picture: this.picture

            })
            .then(() => {
              console.log('News have been Updated')
              alert("Succefully Updated Ev Punting");
              this.$router.push('/prediction/index')
            });
          })
        })



        });
      }
      );


}

  
      
      },
      deleteNews() {
        if (confirm('Are you sure?')) {

            // Delete the Show
            db
            .collection('predictions')
            .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                doc.ref.delete();
                console.log('News Deleted')
                alert("Succefully Deleted Predictions");                
                this.$router.push('/prediction/index');
                });
            });
        }
    }
  }




};
</script>
<style>
</style>
